angular.module('impactx.address').controller('BasketAddressInputCtrl', [
    '$scope',
    '$mdDialog',
    'BasketAddressSelectionPanel',
    'TranslationService',
    BasketAddressInputController
]);

function BasketAddressInputController($scope, $mdDialog, BasketAddressSelectionPanel, TranslationService) {
    var types = {};
    var self = this;
    self.trns = {
        edit: TranslationService.get('edit')
    };

    self.formatAddressValue = function (value) {
        if(value) {
            return value.replace(/,\s/g, '<br/>')
        }
        return '';
    }

    self.openEditDialog = function (event) {
        return $mdDialog.show({
            controller: 'BasketAddressEditDialogCtrl',
            controllerAs: 'basketAddressEditDialogCtrl',
            locals: {
                data: $scope,
            },
            templateUrl: 'modules/address/templates/basket-address-edit-dialog.html',
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: event
        });
    };


    self.openSelectionDialog = function (event, address, addressType) {
        var config = {
            event: event,
            targetElement: address.label + self.clazz,
            data: {
                address: address,
                addressType: addressType,
                enableNew: self.enableNew === undefined ? address.createNew : (self.enableNew && address.createNew),
                enableEdit: self.enableEdit === undefined ? !address.cannotEdit : (self.enableEdit && !address.cannotEdit),
                saveDirect: self.saveDirect,
                disableOwningCom: self.disableOwningCom,
                owningComOptions: self.owningComOptions,
                enableReadOnlyButtons: self.enableReadOnlyButtons,
                enableInheritanceOptions: self.enableInheritanceOptions,
                addressTypes: self.getTypes(),
                entryPoint: self.entryPoint,
                additionalDataForEntryPoint: self.additionalDataForEntryPoint
            },
            trns: self.trns
        };
        BasketAddressSelectionPanel.openPanel(config).then(function (selection) {
            if (impactX.isDefined(selection, 'addressId')) {
                address.selected = selection;
            }
        });
    };

    self.removeSelected = function (address) {
        $scope.$applyAsync(function () {
            delete address.selected;
        });
    };

    self.getTypes = function () {
        types.delivery = !!self.deliveryAddress;
        types.handover = !!self.handoverAddress;
        types.invoice = !!self.invoiceAddress;
        types.contact = !!self.contactAddress;
        return types;
    };

    self.toggleReadOnly = function (type) {
        if (self.checkIfCanToggle(type)) {
            switch (type) {
                case 'delivery':
                    $scope.readonlyDelivery.value = !$scope.readonlyDelivery.value;
                    break;
                case 'handover':
                    $scope.readonlyHandover.value = !$scope.readonlyHandover.value;
                    break;
                case 'invoice':
                    $scope.readonlyInvoice.value = !$scope.readonlyInvoice.value;
                    break;
                case 'contact':
                    $scope.readonlyContact.value = !$scope.readonlyContact.value;
                    break;
            }
        }
    };

    self.checkIfCanToggle = function (type) {

        switch (type) {
            case 'delivery':
                return $scope.readonlyDelivery && !$scope.readonlyDelivery.readOnly;

            case 'handover':
                return $scope.readonlyHandover && !$scope.readonlyHandover.readOnly;

            case 'invoice':
                return $scope.readonlyInvoice && !$scope.readonlyInvoice.readOnly;

            case 'contact':
                return $scope.readonlyContact && !$scope.readonlyContact.readOnly;

            default:
                return false;
        }
    };

    $scope.getTypes = function () {
        types.delivery = !!$scope.deliveryAddress;
        types.handover = !!$scope.handoverAddress;
        types.invoice = !!$scope.invoiceAddress;
        types.contact = !!$scope.contactAddress;
        return types;
    };

    var updateSpecific = function (adr, sourceType, targetType, hasTargetType, isTypeAvail, adrPopup) {
        var found, entries, i;
        if (sourceType !== targetType && isTypeAvail) {
            found = false;
            entries = adrPopup.entries;
            if (adr.addressId !== 0) // don't search for new addresses
            {
                for (i = 0; i < entries.length; i++) {
                    if (entries[i].addressId === adr.addressId) {
                        found = true;
                        break;
                    }
                }
            }
            if (hasTargetType) {
                if (!found) {
                    entries.push(adr);
                }
            }
            else if (adr.addressId !== 0) // don't remove addresses with id === 0
            {
                if (found) {
                    entries.splice(i, 1);
                }
                if (adrPopup.selected && adrPopup.selected.addressId === adr.addressId) {
                    delete adrPopup.selected;
                }
            }
        }
    };

    self.updateOthers = function (adr, sourceType)  // adr is a AddressDTO
    {
        var typesAvail = $scope.getTypes();
        updateSpecific(adr, sourceType, 'delivery', impactX.isDefined(adr, "isDeliveryAddress.value"), typesAvail.delivery, $scope.deliveryAddress);
        updateSpecific(adr, sourceType, 'handover', impactX.isDefined(adr, "isHandoverAddress.value"), typesAvail.handover, $scope.handoverAddress);
        updateSpecific(adr, sourceType, 'invoice', impactX.isDefined(adr, "isInvoiceAddress.value"), typesAvail.invoice, $scope.invoiceAddress);
        updateSpecific(adr, sourceType, 'contact', impactX.isDefined(adr, "isContactAddress.value"), typesAvail.contact, $scope.contactAddress);
    };
}
